import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import NotificationsIcon from "@mui/icons-material/Comment";
import { useNavigate } from "react-router-dom";
import { api_path } from "../../shared.js";
import CommentRenderer from "./CommentRenderer";

export default function CommentBell({ userId }) {
  const [reminders, setReminders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [readIds, setReadIds] = useState([]);

  // โหลดค่าจาก localStorage ตอนเปิดหน้า
  useEffect(() => {
    const savedReadIds = localStorage.getItem("readComments");
    if (savedReadIds) {
      setReadIds(JSON.parse(savedReadIds));
    }
  }, []);

  // โหลด comments จาก API ทุก ๆ 60 วินาที
  useEffect(() => {
    const fetchReminders = async () => {
      try {
        const res = await fetch(
          `${api_path}/customer/get-mention.php?userId=${userId}`
        );
        const data = await res.json();

        console.log("Reminders raw:", data);

        if (Array.isArray(data)) {
          setReminders(data);
        } else if (data && Array.isArray(data.result)) {
          setReminders(data.result);
        } else {
          setReminders([]);
        }
      } catch (error) {
        console.error("Error loading reminders:", error);
        setReminders([]);
      }
    };

    fetchReminders();
    const interval = setInterval(fetchReminders, 60000);
    return () => clearInterval(interval);
  }, [userId]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickReminder = (id, crm_code) => {
    // เพิ่ม id เข้า readIds และบันทึกลง localStorage
    setReadIds((prev) => {
      const newReadIds = prev.includes(id) ? prev : [...prev, id];
      localStorage.setItem("readComments", JSON.stringify(newReadIds));
      return newReadIds;
    });

    setAnchorEl(null);
    navigate(`/s-crm/Customer?customer_id=${crm_code}&activity_id=${id}`);
  };
  const open = Boolean(anchorEl);
  // ✅ คำนวณจำนวนที่ยังไม่ได้อ่าน
  const unreadCount = reminders.filter(
    (r) => !readIds.includes(r.SALES_ACTIVITY_ITEM_ID)
  ).length;

  return (
    <Box>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge
          badgeContent={unreadCount}
          color="error"
          invisible={unreadCount === 0}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: { width: 300, maxHeight: 500, overflowY: "auto" },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Comment
          </Typography>

          {reminders.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No comments
            </Typography>
          ) : (
            reminders.map((r) => {
              const isRead = readIds.includes(r.SALES_ACTIVITY_ITEM_ID);
              return (
                <Box
                  key={r.SALES_ACTIVITY_ITEM_ID}
                  sx={{
                    mt: 1,
                    p: 1,
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    borderRadius: "6px",
                    backgroundColor: isRead ? "#f5f5f5" : "#e3f2fd",
                    transition: "background-color 0.2s ease",
                    fontSize: "12px",
                  }}
                  onClick={() =>
                    handleClickReminder(r.SALES_ACTIVITY_ITEM_ID, r.CRM_CUSCODE)
                  }
                >
                  <CommentRenderer comment={r.COMMENT} />
                  <Typography variant="caption" color="text.secondary">
                    by {r.CreateName} on{" "}
                    {new Date(r.CREATE_DATE).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>
      </Popover>
    </Box>
  );
}
